<template>
  <div class="teen-page teen14">
    <div class="header">
      <h1>围棋：智慧的游戏</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_14.png" alt="围棋">
        <div class="caption">围棋，起源于中国的古老棋类游戏</div>
      </div>

      <h2>一、 起源与历史</h2>
      <p>围棋是起源于中国的古老棋类游戏，相传已有四千多年的历史。它最初是用于占卜和军事训练，后来逐渐发展成为一种益智游戏。</p>

      <h2>二、 规则与玩法</h2>
      <p>围棋使用19×19的棋盘，双方各执黑白棋子。规则简单但变化无穷。棋手通过围地来获得胜利，既要进攻也要防守。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_14.png" alt="围棋对弈">
        <div class="caption">围棋对弈，考验智慧与策略</div>
      </div>

      <h2>三、 围棋的魅力</h2>
      <p>围棋被称为"智慧的体操"，它能锻炼人的逻辑思维、战略眼光和耐心。围棋的变化比宇宙中的原子数量还要多，每一局都是独特的。</p>

      <h2>四、 文化意义</h2>
      <p>围棋不仅是一种游戏，更是一种文化。它体现了中国传统的哲学思想，如阴阳平衡、虚实相生等。围棋也是中日韩三国文化交流的重要纽带。</p>

      <div class="quote-box">
        "围棋之妙，在于无心。" —— 围棋名言
      </div>

      <h2>五、 现代发展</h2>
      <p>近年来，人工智能在围棋领域取得了重大突破。AlphaGo战胜人类顶尖棋手的事件引起了广泛关注，也让更多人对围棋产生了兴趣。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen14'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #fafafa;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #333 0%, #555 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #333;
  border-bottom: 2px solid #666;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #f0f0f0;
  padding: 20px;
  border-left: 4px solid #333;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>